import { isObj } from 'lib/object';

import HTML_PARSER from 'constants/htmlParser';

export const doesAnyDomNodeParentContainName = (parent, name = '') => {
  if (parent) {
    if (parent.name === name) {
      return true;
    }

    if (parent?.parent) {
      return doesAnyDomNodeParentContainName(parent.parent, name);
    }

    return false;
  }

  return false;
};

export const doesAnyDomNodeParentContainAttribute = ({
  attributeName = 'class',
  attributeValue = '',
  parent,
}) => {
  if (parent) {
    if (parent.attribs[attributeName]?.includes(attributeValue)) {
      return true;
    }

    if (parent?.parent) {
      return doesAnyDomNodeParentContainAttribute({
        attributeName,
        attributeValue,
        parent: parent.parent,
      });
    }

    return false;
  }

  return false;
};

export const getChildrenPlainText = (children) => {
  const result = [];

  const recursivelyGetChildrenPlainText = (_children) => {
    if (typeof _children === 'string') {
      return result.push(_children.trim());
    }

    if (Array.isArray(_children)) {
      return _children.forEach((child) =>
        recursivelyGetChildrenPlainText(child)
      );
    }

    if (isObj(_children) && !Array.isArray(_children)) {
      return recursivelyGetChildrenPlainText(_children.props.children);
    }
  };

  recursivelyGetChildrenPlainText(children);

  return result.join(' ').trim();
};

export const hasLineBreakChild = (children) =>
  children?.some(
    ({ name, data }) => name === HTML_PARSER.NAME_BR || isLineBreaker(data)
  );

export const isInlineText = (type) => type === 'text';

export const isLineBreaker = (str) => /^\s{1,}$/.test(str);

export const isYoutubeIframe = (str) => str.includes('www.youtube.com');

export const strip = (str) => str.replace(/(\r\n|\n\r|\n|\r)/gm, '');

export const toChildrenWithoutLineBreaks = (children) =>
  children?.filter(
    (child) =>
      child?.name !== HTML_PARSER.NAME_BR &&
      !isLineBreaker(child?.data) &&
      (child?.data || child?.children?.[0]?.data)
  ) ?? [];
